import React, { useEffect, useRef } from 'react';
import SiteFooter from '../components/SiteFooter';

// Renders the self-contained UpperCircuitStocks masterclass embed block
// (fonts + scoped CSS + markup + script) verbatim from /masterclass-embed.html,
// sitting between the global site header and the site footer.
export default function MasterclassPage() {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || container.childElementCount > 0) return;

    fetch('/masterclass-embed.html')
      .then((r) => r.text())
      .then((html) => {
        if (!container || container.childElementCount > 0) return;
        container.innerHTML = html;
        // innerHTML does not execute <script> tags — re-create them so the
        // countdown, FAQ, reveal animations and form all run.
        container.querySelectorAll('script').forEach((oldScript) => {
          const s = document.createElement('script');
          for (const attr of oldScript.attributes) s.setAttribute(attr.name, attr.value);
          s.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(s, oldScript);
        });
      })
      .catch((err) => console.error('Failed to load masterclass embed:', err));
  }, []);

  return (
    <>
      <div ref={containerRef} data-testid="masterclass-embed" />
      <SiteFooter />
    </>
  );
}
